import { useState } from 'react';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

export const useTogglePasswordVisibility = () => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [passwordIcon, setPasswordIcon] = useState(faEye);

  const handlePasswordVisibility = () => {
    if (passwordIcon === faEye) {
      setPasswordIcon(faEyeSlash);
      setPasswordVisibility(!passwordVisibility);
    } else if (passwordIcon === faEyeSlash) {
      setPasswordIcon(faEye);
      setPasswordVisibility(!passwordVisibility);
    }
  };

  return {
    passwordVisibility,
    passwordIcon,
    handlePasswordVisibility,
  };
};
